import { render, staticRenderFns } from "./DepartmentPickerResultsList.vue?vue&type=template&id=1ddcb7b0&scoped=true"
import script from "./DepartmentPickerResultsList.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentPickerResultsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentPickerResultsList.vue?vue&type=style&index=0&id=1ddcb7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcb7b0",
  null
  
)

export default component.exports